
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeTaskDialog extends Serenity.EntityDialog<ProdottiEsperienzeTaskRow, any> {
        protected getFormKey() { return ProdottiEsperienzeTaskForm.formKey; }
        protected getIdProperty() { return ProdottiEsperienzeTaskRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeTaskRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiEsperienzeTaskRow.nameProperty; }
        protected getService() { return ProdottiEsperienzeTaskService.baseUrl; }
        protected getDeletePermission() { return ProdottiEsperienzeTaskRow.deletePermission; }
        protected getInsertPermission() { return ProdottiEsperienzeTaskRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiEsperienzeTaskRow.updatePermission; }

        protected form = new ProdottiEsperienzeTaskForm(this.idPrefix);

    }
}